module.exports = __webpack_public_path__ + "img/071.e26b29a1.png";